document.addEventListener("DOMContentLoaded", function () {

    const params = new URLSearchParams(window.location.search);

    const bundle = params.get("bundle");
    const purchase = params.get("purchase");

    function clickOptionByText(text) {
        const elements = document.querySelectorAll('[role="button"]');

        for (const el of elements) {
            if (el.innerText && el.innerText.trim().includes(text)) {
                el.click();
                console.log("Selected:", text);
                return true;
            }
        }

        return false;
    }

    function autoSelect() {

        // Select Bundle First
        const bundleButtons = document.querySelectorAll('[role="button"]');

        bundleButtons.forEach(btn => {

            const text = btn.innerText || '';

            if (bundle === '1' && text.includes('1 Pack')) {
                btn.click();
                console.log('Selected Bundle 1');
            }

            if (bundle === '2' && text.includes('2 Pack')) {
                btn.click();
                console.log('Selected Bundle 2');
            }

            if (bundle === '3' && text.includes('3 Pack')) {
                btn.click();
                console.log('Selected Bundle 3');
            }

        });

        // Select Purchase Option After Bundle Updates
        setTimeout(() => {

            if (purchase === "subscription") {
                clickOptionByText("Subscribe and Save");
            }

            if (purchase === "onetime") {
                clickOptionByText("One-time purchase");
            }

        }, 1000);
    }

    // Replo loads asynchronously, so retry a few times
    setTimeout(autoSelect, 1500);
    setTimeout(autoSelect, 3000);
    setTimeout(autoSelect, 5000);

});